import React from "react";
export const SectionSkeleton = () => {
  const colorScheme = {
    "gray.200": "#EAECF0",
    "gray.300": "#D0D5DD"
  };
  const shimmerAnimationStyle = {
    backgroundColor: colorScheme["gray.200"],
    backgroundImage: `linear-gradient(90deg, ${colorScheme["gray.200"]} 0%, ${colorScheme["gray.300"]} 40%, ${colorScheme["gray.200"]} 80%)`,
    backgroundSize: "200% 100%",
    animation: "shimmer 2s ease-in-out infinite"
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "112px 0px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      gap: "48px",
      width: "90%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "60%",
      gap: "24px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      gap: "16px",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      gap: "8px",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      height: "50px",
      ...shimmerAnimationStyle
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: "90%",
      height: "50px",
      ...shimmerAnimationStyle
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      width: "90%",
      gap: "8px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      height: "10px",
      ...shimmerAnimationStyle
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: "80%",
      height: "10px",
      ...shimmerAnimationStyle
    }
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      width: "80%",
      gap: "12px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "120px",
      height: "50px",
      borderRadius: "12px",
      ...shimmerAnimationStyle
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: "120px",
      height: "50px",
      borderRadius: "12px",
      ...shimmerAnimationStyle
    }
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      width: "90%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "20px",
      ...shimmerAnimationStyle
    }
  }, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2 56.0002H18.4837C16.8681 56.0002 16.0604 56.0002 15.6864 55.6808C15.3618 55.4036 15.1896 54.9878 15.2231 54.5623C15.2617 54.0719 15.8328 53.5008 16.9752 52.3584L39.6497 29.6839C40.7057 28.6279 41.2338 28.0998 41.8426 27.902C42.3782 27.728 42.9551 27.728 43.4907 27.902C44.0996 28.0998 44.6276 28.6279 45.6837 29.6839L56 40.0002V43.2002M43.2 56.0002C47.6804 56.0002 49.9206 56.0002 51.6319 55.1283C53.1372 54.3613 54.3611 53.1375 55.1281 51.6322C56 49.9209 56 47.6807 56 43.2002M43.2 56.0002H20.8C16.3196 56.0002 14.0794 56.0002 12.3681 55.1283C10.8628 54.3613 9.63893 53.1375 8.87195 51.6322C8 49.9209 8 47.6807 8 43.2002V20.8002C8 16.3198 8 14.0796 8.87195 12.3683C9.63893 10.863 10.8628 9.63918 12.3681 8.87219C14.0794 8.00024 16.3196 8.00024 20.8 8.00024H43.2C47.6804 8.00024 49.9206 8.00024 51.6319 8.87219C53.1372 9.63918 54.3611 10.863 55.1281 12.3683C56 14.0796 56 16.3198 56 20.8002V43.2002M28 22.6669C28 25.6124 25.6122 28.0002 22.6667 28.0002C19.7211 28.0002 17.3333 25.6124 17.3333 22.6669C17.3333 19.7214 19.7211 17.3336 22.6667 17.3336C25.6122 17.3336 28 19.7214 28 22.6669Z",
    stroke: colorScheme["gray.300"],
    strokeWidth: "3.45",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("style", {
    dangerouslySetInnerHTML: {
      __html: `
                @keyframes shimmer {
                  0% {
                    background-position: 200% 0;
                  }
                  100% {
                    background-position: -200% 0;
                  }
                }
          `
    }
  }));
};
//# sourceMappingURL=SectionSkeleton.js.map